import React from 'react'
import { AuthModalProvider } from "../../context/AuthModalContext"

export const WrapRootElement = ({ element }) => (
  <AuthModalProvider>
    {element}
  </AuthModalProvider>
)

export default WrapRootElement